import { SUPPLIER_NAMES } from '@luxuryescapes/contract-svc-bedbank/constants/suppliers';

import { Bundle, BundleHotelRule } from '~/services/AccommodationService';

export type BoardCode = BundleHotelRule['boardCodes'][number];
export type CancellationPolicy = BundleHotelRule['cancellationPolicies'][number];
export type BedbankSupplier = BundleHotelRule['lppSupplierAllowlist'][number];
export type BundleStatus = Bundle['status'];

export const ALL_BOARD_CODES: Array<BoardCode> = ['RO', 'BB', 'HB', 'FB', 'AI'];

export const BOARD_CODE_LABELS: Record<BoardCode, string> = {
  RO: 'Room Only',
  BB: 'Bed & Breakfast',
  HB: 'Half Board',
  FB: 'Full Board',
  AI: 'All Inclusive',
};

export const ALL_CANCELLATION_POLICIES: Array<CancellationPolicy> = ['RF', 'NRF'];

// Mirrors the BedbankSuppliers enum on svc-accommodation. Keep in sync if a new supplier ships.
export const ALL_BEDBANK_SUPPLIERS: Array<BedbankSupplier> = SUPPLIER_NAMES;

export const CANCELLATION_POLICY_LABELS: Record<CancellationPolicy, string> = {
  RF: 'Refundable',
  NRF: 'Non-Refundable',
};

export const EXAMPLE_NIGHTS = 10;
export const EXAMPLE_GUESTS = 4;

export const ALL_BUNDLE_STATUSES: Array<BundleStatus> = ['draft', 'content-approved'];

export const BUNDLE_STATUS_LABELS: Record<BundleStatus, string> = {
  draft: 'Draft',
  'content-approved': 'Content Approved',
};

export const bundleStatusPillProps = (status: BundleStatus): { label: string; color: 'success' | 'default' } => {
  const isApproved = status === 'content-approved';
  return {
    label: isApproved ? 'active' : 'inactive',
    color: isApproved ? 'success' : 'default',
  };
};

// Mirrors svc-accommodation's MAX_BUNDLES_PER_PROPERTY — the backend enforces the
// cap; this only keeps the 409-conflict copy in step with it.
export const MAX_BUNDLES_PER_PROPERTY = 4;
